<template>
  <div v-if="note" class="note">
    <div class="createdOn">{{note.creationDate}}</div>
    <div class="noteText">
      {{note.note}}
    </div>
    <div class="noteAction">
      <button @click="_toggleDeletePrompt">
        <v-icon>mdi-delete-outline</v-icon>
      </button>
      <div v-if="isDeletePromptVisible" class="confirmPopup">
        <div class="option confirm" @click="_confirmDelete">Click to confirm</div>
        <div class="option" @click="_toggleDeletePrompt">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
export default {
  components: {},
  name: "PatientNote",
  data: () => ({
    isDeletePromptVisible: false
  }),
  created: () => {},
  props: {
    note: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: -1
    }
  },
  methods: {
    _toggleDeletePrompt () {
      this.isDeletePromptVisible = !this.isDeletePromptVisible;
    },
    _confirmDelete () {
      // this._toggleDeletePrompt();
      this.$emit('delete-note', { noteIndex: this.index, note: this.note });
    }
  },
};
</script>

<style lang="scss" scoped>
.note {
  background-color: #ffffff2a;
  padding: 1rem 2rem;
  border-radius: 8px;
  border: 1px solid #00b65b;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.123);
  color: rgb(48, 48, 48);
  display: flex;
  margin-bottom: 1rem;
  align-items: flex-start;
  .createdOn {
    flex: 2;
    font-weight: 600;
  }
  .noteText {
    flex: 15;
  }
  .noteAction {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    // align-items: flex-end;
    flex: 1;
    // background-color: #00b65b;
    text-align: center;
    padding-left: 2rem;
    position: relative;
    .confirmPopup {
      background-color: rgb(241, 241, 241);
      border-color: 2px solid red;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.212);
      width: 150px;
      cursor: pointer;
      height: 80px;
      color: rgb(29, 28, 28);
      position: absolute;
      z-index: 999;

      .option {
        padding-bottom: 8px;
        font-size: 0.8rem;
      }

      .confirm {
        padding-top: 8px;
        color: red;
        font-weight: 600;
        font-size: 1rem;
      }

      top: 0px;
      right: -15px;
    }
  }
}
</style>
